import React from 'react';
import Select from '../../commonComponents/util/Select';

export default class PrintInfo extends React.Component {
    onChange(e) {
        this.props.updateApplication(e.target.name, e.target.value);
    }
    render() {
        return (
            <div>
                <p className="medium-text">Print Instructions</p>
                <br />
                <div className="info-row">
                    <div className="column-third">
                        <label className="input-label">Card Type</label>
                        <Select clearable={true} options={this.props.cardTypes} value={this.props.selectedCardType} tabIndex={500}
                            name='cardTypeId' title="Card Type" onChange={this.onChange.bind(this)} />
                    </div>
                    <div className="column-two-thirds">
                        <label className="empty-label"></label>
                        <input type="text" tabIndex={510} placeholder="Enter any other instructions" value={this.props.printInstructions} onChange={(e) => this.props.updateApplication('printInstructions', e.target.value)} />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/PrintInfo.jsx